function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1191",
  "data-name": "Group 1191",
  transform: "translate(-844 -451)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_8",
  "data-name": "Ellipse 8",
  transform: "translate(844 451)",
  fill: "#675b34",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.25,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_748",
  "data-name": "Path 748",
  d: "M6.923,0a6.923,6.923,0,0,1,6.923,6.923,7.058,7.058,0,0,1-2.705,5.49,6.683,6.683,0,0,1-4.218,1.433A6.923,6.923,0,0,1,6.923,0Z",
  transform: "translate(847.077 454.078)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_652",
  "data-name": "Group 652",
  transform: "translate(851.022 458.037)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  x2: 5.926,
  transform: "translate(0 2.963)",
  fill: "none",
  stroke: "#675b34",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_13",
  "data-name": "Line 13",
  y2: 5.926,
  transform: "translate(2.963)",
  fill: "none",
  stroke: "#675b34",
  strokeLinecap: "round",
  strokeWidth: 1.5
})));

var SvgPlusWhite = function SvgPlusWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-white.971d0e5f.svg";
export { ForwardRef as ReactComponent };